import classes from 'components/widgets/ProjectSummary/components/NoApplicableData/NoApplicableData.module.scss';

interface Props {
    id: string;
}

export const NoApplicableData = ({ id }: Props) => {
    return (
        <div id={`${id}_noApplicableData`} className={classes.text}>
            Not applicable with the applied filter
        </div>
    );
};
